import { render } from "./supportAskQuestion.vue?vue&type=template&id=79a3a1ce&scoped=true&ts=true"
import script from "./supportAskQuestion.vue?vue&type=script&lang=ts"
export * from "./supportAskQuestion.vue?vue&type=script&lang=ts"

import "./supportAskQuestion.vue?vue&type=style&index=0&id=79a3a1ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a3a1ce"]])

export default __exports__